
import { useNavigate } from 'react-router-dom';
import { Search, Icon, Header, Message } from 'semantic-ui-react';

import { JoyyaHeader } from '../../../../components/JoyyaHeader';
import { usePeopleSearch } from '../shared/usePeopleSearch';
import { PersonListItem } from '../shared/PersonListItem';

import styles from './TeacherPeopleView.module.css';

const TeacherPeopleView = () => {
    const navigate = useNavigate();
    const { search, loading, data, handleSearchChange, shouldShowSearch } = usePeopleSearch();

    return (
        <>
            <JoyyaHeader />
            <div className="mobile-frame">
                <Header as="h2">
                    <span className={styles.header}>
                        <Icon name="arrow left" className={styles.backBtn} onClick={() => navigate(-1)} />
                        People
                    </span>
                </Header>

                {shouldShowSearch && (
                    <Search
                        loading={loading}
                        input={{ fluid: true }}
                        className={styles.search}
                        size="large"
                        placeholder="Search..."
                        open={false}
                        onSearchChange={handleSearchChange}
                        value={search}
                    />
                )}

                <div>
                    {data?.users.map((p: any) => (
                        <PersonListItem
                            key={p.id}
                            person={p}
                            onClick={() => navigate(`/people/${p.id}`)}
                        />
                    ))}
                </div>

                {shouldShowSearch && !loading && data?.users.length > 10 && (
                    <Message style={{ marginTop: '1em' }}>
                        <Message.Header>Don't see who you're looking for?</Message.Header>
                        <p>Try a more specific search — we don't load everyone at once.</p>
                    </Message>
                )}
            </div>
        </>
    );
};

export { TeacherPeopleView };
